import { combineReducers } from 'redux';
import { companiesListSlice } from './CompanyListPage/redux/slice';
import { companySettingsReducer } from './CompanySettingsPage/reducer';

export const companiesReducer = combineReducers({
  list: companiesListSlice.reducer,
  companySettings: companySettingsReducer,
});
